<template>
  <div class="storeManage-list">
    <GlobalInfoBar
        title="线上门店管理"
        content="配置线上客户端小程序/H5页面，推荐展示门店信息（线上门店信息默认与 "
        consent="门店管理-门店列表 "
        confeiger="信息同步）"
        pathName="/storeManage/index"
    />
    <GlobalChunkNo
        icon="search"
        title="筛选查询"
    >
      
      <div slot="filter">
        <storeManageFrom />
      </div>
      <p style="margin-bottom: 10px;color: #F83232;font-size: 15px;">说明: 为提升管理效率，启用状态关闭的情况下，门店店长可填写门店营业时间、门店地址、上传门店照片（后台正式开启后则门店店长无法修改）</p>
      <storeManageTable />
    </GlobalChunkNo>
  </div>
</template>

<script>
import storeManageFrom from './From'
import storeManageTable from './Table'
export default {
  name: 'storeManage-list',
  components: {storeManageFrom,storeManageTable},
  data(){
    return{
      userName:"",
      userPhone:"",
      roleId:"",
    }
  },
  methods:{
    
  }
}
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.merchant-list{
}
</style>
